import VerificationCodeStep from './VerificationCodeStep';

export default VerificationCodeStep;
